import { useSyncExternalStore } from 'react';

/**
 * A screen opened in a window over the page in use (Angela, 22 Oct 2026): the
 * Appointments right-click menu opens Customer details, Create invoice … here
 * instead of leaving Appointments, so × (or finishing) puts staff back where
 * they were. The window shows the same screen in a frame without the top menu
 * and sidebar (`isEmbedded`).
 */
export interface PageWindowState {
  url: string;
  title: string;
  onClose?: () => void;
}

let current: PageWindowState | null = null;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

export function openPageWindow(next: PageWindowState): void {
  current = next;
  emit();
}

export function closePageWindow(): void {
  const closing = current;
  current = null;
  emit();
  closing?.onClose?.();
}

export function usePageWindow(): PageWindowState | null {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => current,
  );
}

/** True inside a page window's frame: the page draws without the top menu and sidebar. */
export function isEmbedded(): boolean {
  try {
    return typeof window !== 'undefined' && window.self !== window.top;
  } catch {
    return true;
  }
}
